import {Button, Card, Result} from "antd";
import {Link} from "react-router-dom";
import React from "react";

const ErrorNotFound = () => <Card style={{marginTop: 16, marginRight: 20}}>
    <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Button type="primary">
            <Link to={'/'}>Back to Home</Link>
        </Button>}
    />
</Card>;

export default ErrorNotFound;